<div class="page-content" fxLayout="column">
    <div class="page-bar">
        <div style="padding:6px 20px">
            Welcome, {{name}}
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutWrap style="padding:40px;overflow:auto;">
        <div class="item" style="width:250px">
            <div class="item-header padding" *accessRights="['STAFF_DESIGNATION', 'STAFF_DEPARTMENT', 'STAFF_MANAGEMENT']">
                Staff Management
            </div>
            <ul>
                <li><a routerLink="/staff/list" *accessRights="['STAFF_MANAGEMENT']">Staff List</a></li>
                <li><a routerLink="/staff/designation/list" *accessRights="['STAFF_DESIGNATION']">Designation</a></li>
                <li><a routerLink="/staff/department/list" *accessRights="['STAFF_DEPARTMENT']">Department</a></li>
            </ul>
        </div>

        <div class="item" style="width:250px" *accessRights="['COMPANY_MANAGEMENT']">
            <div class="item-header padding">
                {{companyString}} Management
            </div>
            <ul>
                <li><a routerLink="/company" *accessRights="['COMPANY_MANAGEMENT']">{{companyString}}</a></li>
            </ul>
        </div>

        <div class="item" style="width:250px" *accessRights="['ASSET_MANAGEMENT','ASSET_IMPORT', 'ASSET_TYPE', 'ASSET_GROUP']">
            <div class="item-header padding">
                {{assetString}}  Management
            </div>
            <ul>
                <li><a routerLink="/asset/list" *accessRights="['ASSET_MANAGEMENT']">{{assetString}} List</a></li>
                <li><a routerLink="/asset/import" *accessRights="['ASSET_IMPORT']">Bulk Import</a></li>
                <li><a routerLink="/asset/type/list" *accessRights="['ASSET_TYPE']">{{assetString}} Type</a></li>
                <li><a routerLink="/asset/group/list" *accessRights="['ASSET_GROUP']">{{assetString}} Group</a></li>
            </ul>
        </div>
        <div class="item" style="width:250px" *accessRights="['WORKORDER_MANAGEMENT','GUIDED_INSPECTION']">
            <div class="item-header padding">
                Work Order Management
            </div>
            <ul>
                <li><a routerLink="/action/list">Work Order List</a></li>
            </ul>
        </div>
        <div class="item" style="width:250px" *accessRights="['ACTION_MANAGEMENT']">
            <div class="item-header padding">
                Action Management
            </div>
            <ul>
                <li><a routerLink="/action/list" *accessRights="['ACTION_MANAGEMENT']">Action List</a></li>
            </ul>
        </div>
        <div class="item" style="width:250px" *accessRights="['PROCESS_MANAGEMENT']">
            <div class="item-header padding">
                Process Management
            </div>
            <ul>
                <li><a routerLink="/process/list" *accessRights="['PROCESS_MANAGEMENT']">Process List</a></li>
            </ul>
        </div>

        <div class="item" style="width:250px" 
                *accessRights="['REPORT_LIVE_TRANSACTION', 'REPORT_LIVE_TRANSACTION_SINGLE', 'REPORT_HIST_TRANSACTION', 'REPORT_HIST_TRANSACTION_SINGLE', 'REPORT_OVERALL_STATUS', 
                'REPORT_DEMO_SUBCON_OVERALL_SUMMARY', 'REPORT_DEMO_SUBCON_DAILY_PRODUCTION','REPORT_DEMO_MAINCON_OVERALL_SUMMARY','REPORT_DEMO_MAINCON_SEGMENT_TRACKING',
                'REPORT_CONTECH_OVERALL_SUMMARY', 'REPORT_POKB_OVERALL_SUMMARY', 'REPORT_POKB_SEGMENT_TRACKING', 'REPORT_DAILY_PRODUCTION', 'REPORT_RBV_OVERALL_STATUS']">
            <div class="item-header padding">
                Reports
            </div>
            <ul>
                <li><a routerLink="/report/livetransaction" *accessRights="['REPORT_LIVE_TRANSACTION']">Live Transaction</a></li>
                <li><a routerLink="/report/livetransactionS" *accessRights="['REPORT_LIVE_TRANSACTION_SINGLE']">Live Transaction</a></li>
                <li><a routerLink="/report/historicaltransaction" *accessRights="['REPORT_HIST_TRANSACTION']">Historical Transaction</a></li>
                <li><a routerLink="/report/historicaltransactionS" *accessRights="['REPORT_HIST_TRANSACTION_SINGLE']">Historical Transaction</a></li>
                <li><a routerLink="/report/overallstatussummary" *accessRights="['REPORT_OVERALL_STATUS']">Overall Status Summary</a></li>
                <!--demo-->
                <li><a routerLink="/report/subconoverallsummary" *accessRights="['REPORT_DEMO_SUBCON_OVERALL_SUMMARY']">Subcon Overall Summary</a></li>
                <li><a routerLink="/report/subcondailyproduction" *accessRights="['REPORT_DEMO_SUBCON_DAILY_PRODUCTION']">Subcon Daily Production</a></li>
                <li><a routerLink="/report/mainconoverallsummary" *accessRights="['REPORT_DEMO_MAINCON_OVERALL_SUMMARY']">Maincon Overall Summary</a></li>
                <li><a routerLink="/report/mainconsegmenttracking" *accessRights="['REPORT_DEMO_MAINCON_SEGMENT_TRACKING']">Maincon Segment Tracking</a></li>
                <!--T08-->
                <li><a routerLink="/report/contechoverallsummary" *accessRights="['REPORT_CONTECH_OVERALL_SUMMARY']">Contech Overall Summary</a></li>
                <li><a routerLink="/report/pokboverallsummary" *accessRights="['REPORT_POKB_OVERALL_SUMMARY']">POKB Overall Summary</a></li>
                <li><a routerLink="/report/pokbsegmenttracking" *accessRights="['REPORT_POKB_SEGMENT_TRACKING']">POKB Segment Tracking</a></li>
                <li><a routerLink="/report/dailyproduction" *accessRights="['REPORT_DAILY_PRODUCTION']">Daily Production</a></li>
                <!-- RBV-->
                <li><a routerLink="/report/rbvoverallstatussummary" *accessRights="['REPORT_RBV_OVERALL_STATUS']">RBV Overall Status Summary</a></li>
            </ul>
        </div>

        <div class="item" style="width:250px" *accessRights="['ADMINISTRATIVE_PROFILE','ADMINISTRATIVE_AUDIT_LOG', 'ADMINISTRATIVE_ACCOUNT']">
            <div class="item-header padding">
                Administrative
            </div>
            <ul>
                <li><a routerLink="/administrative/account/list" *accessRights="['ADMINISTRATIVE_ACCOUNT']">Account</a></li>
                <li><a routerLink="/administrative/auditlog" *accessRights="['ADMINISTRATIVE_AUDIT_LOG']">Audit Log Report</a></li>
                <li><a routerLink="/administrative/profile/list" *accessRights="['ADMINISTRATIVE_PROFILE']">Profile</a></li>
            </ul>
        </div>

        <div class="item" style="width:250px">
            <div class="item-header padding">
                Download Guides
            </div>
            <ul>
                <li><a routerLink="/guidebook/list">List</a></li>
            </ul>
        </div>
    </div>
</div>